const getBaseURL = () => {
  const host = window.location.hostname;

  if (host.includes("localhost") || host.includes("127.0.0.1")) {
    return "http://localhost:8080";
  }

  // if (host.includes("airacore.in")) {
  //   return "https://apikunaldoorandmore.airacore.in";
  // }

  return "https://api.kunaldoorandmore.com";
};

const environment = {
  Base_URL: getBaseURL(),
};

export default environment;
